// frontend/src/api/jwt.js
//
// Small, dependency-free JWT *payload* decoder — base64url-decodes the
// middle segment of a `header.payload.signature` token and JSON-parses it.
//
// IMPORTANT — DISPLAY ONLY, NEVER TRUST THIS CLIENT-SIDE:
// This performs NO signature verification whatsoever. It cannot prove the
// token is genuine, untampered, or unexpired — a malicious user can put
// literally any JSON they want into this segment of a token they hold.
// The backend (worker/lib/auth.js's verifyJWT) is the ONLY trusted verifier
// and the only place authorization decisions are made. Use the value
// returned here ONLY for convenience UI display (e.g. "which hotel am I
// logged into" from the token's `tenant_id` claim) — never to gate access
// to a route, a feature, or any sensitive UI, and never pass it to the
// backend as if it were authoritative.
export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    // atob can choke on missing padding depending on segment length.
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}
